import { useReorderTherapyAttributes } from '@/api/glow-up/glow-up.hooks';
import { SortableList } from '@/components/ui/sortable-list';
import { TherapyAttribute } from '@repo/types/src/glow-up';
import { TherapyAttributeCard } from './TherapyAttributeCard';

type TherapyAttributeListProps = {
  attributes: TherapyAttribute[];
  refetch: () => void;
};

export const TherapyAttributeList = ({
  attributes,
  refetch,
}: TherapyAttributeListProps) => {
  const reorder = useReorderTherapyAttributes();

  if (!attributes.length) {
    return (
      <p className="text-sm text-muted-foreground">
        Aucun attribut de thérapie pour le moment.
      </p>
    );
  }

  return (
    <SortableList
      items={attributes}
      renderItem={(attribute) => (
        <div className="flex flex-wrap gap-4 py-1">
          <TherapyAttributeCard attribute={attribute} refetch={refetch} />
        </div>
      )}
      onReorder={(items) => reorder.mutate(items)}
    />
  );
};
